// extracted by mini-css-extract-plugin
export default {"complaintRecordList":"styles_complaintRecordList__U1CrN"};